<form
  [ngClass]="{
    collapsed: isCollapsible,
    'full-size': showInput,
    'no-background-with-border': noBackgroundWithBorder,
    'border-focus': showInputSearch && !platformService.isMobile(),
    'border-focus-mobile': showInputSearch && platformService.isMobile(),
    'form-w-search': !showInputSearch,
    'light-gray-background':
      isLightGrayBackground && platformService.isMobile(),
  }"
  class="form-w"
>
  @if (showInputSearch) {
    <input
      class="no-clear-button"
      #inputElement
      [formControl]="query"
      [value]="query.value"
      type="search"
      (focusout)="focusout()"
      [ngClass]="{
        'full-size': showInput,
        show: !isCollapsible || showInput,
        'light-gray-background': isLightGrayBackground,
      }"
      [placeholder]="placeholder"
      (focus)="focusIn()"
    />
  }

  <button (click)="focusInButton()" class="button-container" type="submit">
    @if (showInputSearch && query.value.length > 0) {
      <i
        class="a-icon boschicon-bosch-ic-close icon-x"
        (click)="clearSearchBar()"
      ></i>
    }

    <i class="boschicon-bosch-ic-search"></i>
  </button>
</form>
